export default __webpack_public_path__ + "static/media/img--interiors-3.b2e9e690.jpg";